define('views/components/country_distributor/cd_list',['require','views/base/list_view','views/components/country_distributor/country_distributor','text!templates/components/country_distributor/cd_list.html'],function(require){

    var BaseListView = require('views/base/list_view');
    var ChildView = require('views/components/country_distributor/country_distributor');

    var temp = require("text!templates/components/country_distributor/cd_list.html");
    return BaseListView.extend({
        template: _.template(temp),
        childView: ChildView
    });
});

